import React, { useState } from 'react';

const AppContext = React.createContext();

const AppContextProvider = ({children}) => {
    const [loading, setLoading] = useState(true);
    const [menu, setMenu] = useState(false);
    const [changeColor, setChangeColor] = useState(false);
    const [transition, setTransition] = useState(false);
    return (
        <AppContext.Provider value={{
            loading,
            setLoading,
            menu,
            setMenu,
            changeColor, 
            setChangeColor,
            transition, 
            setTransition
        }}>
            {children}
        </AppContext.Provider>
    );
}

export {AppContextProvider, AppContext};